import EvaluacionDesempenio from './EvaluacionDesempenio'

const DEFAULT_EVALUACION_STATUS = 1

export default class EvaluacionDisciplinaAdministrativa extends EvaluacionDesempenio {
  idEstatus
  actas
  incidencias
  reconocimientos
  estimulos
  actasAdministrativas

  constructor(idEvaluado) {
    super(idEvaluado)
    this.idEstatus = DEFAULT_EVALUACION_STATUS
    this.actas = []
    this.incidencias = []
    this.reconocimientos = []
    this.estimulos = []
    this.actasAdministrativas = []
  }
}
